<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">{{ $t("auto.trendyolFeature") }}</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.integration") }}</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.trendyolEntegration" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.channelCount") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.trendyolChannelCount" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.questionAnswerManagement") }}</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.trendyolQuestionAnswer" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.automaticAnswerSystem") }}</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.trendyolAutomaticAnswer" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.chatbotCommentControl") }}</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.trendyolCommentChatbotManage" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems, Features } from "./index";

export default {
    name: "TrendyolFeature",
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            trendyolEntegration: true,
            trendyolChannelCount: 0,
            trendyolQuestionAnswer: false,
            trendyolAutomaticAnswer: false,
            trendyolCommentChatbotManage: false,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.TRENDYOL);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: "trendyol", ...this.featureForm };
                response[Features.TRENDYOL.CHANNEL_COUNT] = +v.trendyolChannelCount || 0;
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.TRENDYOL);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
